import { render } from "./SignupView.vue?vue&type=template&id=62606b73&ts=true"
import script from "./SignupView.vue?vue&type=script&lang=ts"
export * from "./SignupView.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__